import { useApiClient } from '@m43/core';
import { compact } from 'lodash';
import { UserOption } from '@mark43/cad-api';
import { useCallback } from 'react';
import { ElasticSearchResource, ElasticUser } from '@mark43/rms-api';

export function formatElasticUser(elasticUser: ElasticUser) {
    const id = elasticUser.badgeNumber ?? elasticUser.externalCadId;
    return compact([elasticUser.fullName, id ? `#${id}` : undefined]).join(' ');
}

function mapElasticUserToUserOption(elasticUser: ElasticUser): UserOption {
    return {
        value: elasticUser.id,
        label: formatElasticUser(elasticUser),
        agencyId: elasticUser.departmentAgencyId,
    };
}

export function useUserOptionSearch(config?: { includeDisabled: true }) {
    const apiClient = useApiClient();
    const searchUserOptions = useCallback(
        (query: string) => {
            return apiClient
                .request<ElasticSearchResource.SearchUsers>({
                    method: 'POST',
                    data: {
                        // @ts-expect-error optionals not produced correctly in types
                        elasticQuery: {
                            quickSearchQuery: query,
                            isDisabled: config?.includeDisabled ? undefined : false,
                        },
                        sorts: [{ sortKey: 'USER_FULL_NAME', sortType: 'ALPHABETICAL_A_TO_Z' }],
                    },
                    url: 'elastic_search/users/',
                    service: 'RMS',
                })
                .then((response) => {
                    return response.data.data?.items.map(mapElasticUserToUserOption) ?? [];
                });
        },
        [apiClient, config]
    );
    return { searchUserOptions };
}
